export default {
  'businessUser.newUser': 'New User',
  'businessUser.searchPlaceholder': 'User Name/Phone Number/Email',
  'businessUser.role': 'Role',
  'businessUser.userID': 'User ID',
  'businessUser.userName': 'User Name',
  'businessUser.phoneNumber': 'Phone Number',
  'businessUser.department': 'Department',
  'businessUser.addSuccess': 'Add user successfully',
  'businessUser.editSuccess': 'Modify user successfully',
  'businessUser.delSuccess': 'Delete user successfully',
  'businessUser.delConfirm': 'Are you sure to delete this user?',
  'businessUser.unblockConfirm': 'Are you sure to unblock this user?',
  'businessUser.blockConfirm': 'Are you sure to block this user?',
  'businessUser.unblockSuccess': 'Unblock user successfully',
  'businessUser.blockSuccess': 'Block user successfully',
  'businessUser.user': 'User',
  'businessUser.bcareAdmin': 'Bcare Admin',
  'businessUser.superAdmin': 'Super Admin',
  'businessUser.customerAdmin': 'Customer Admin',
  'businessUser.departmentAdmin': 'Department Admin',
  'businessUser.addUser': 'Add User',
  'businessUser.editUser': 'Edit User',
  'businessUser.customerAdminTips':
    'Created by Super Admin, inherit similar privileges and could have multiple users with same role. Able to view and manage everything related to the Enterprise.',
  'businessUser.departmentAdminTips':
    'Able to grant access control and manage specific departmental accounts and its member only.',
  'businessUser.userTips':
    'Able to view selective menus with restricted access control relevant to their function only.',
};

